import React, { useState, useEffect } from "react";
import api, { getReportURL } from "@api";
import { Form } from "@components";
import { SystemAppNameModel } from "@api/types/systemappname";
import { SystemAppNameDetail } from "./detail";
import { M_TABLE_HEADERS_SYSTEM_APPNAME } from "../constants";
import { Cell } from "@components/table/types";
import { Box } from "@material-ui/core";
import { FilterType, Table } from "@components";
import { useSystemAppNameStore } from "../../../../../store/hooksy";
import { MaintenanceBreadcrumbs } from "../breadcrumbs";
import { REPORT_TYPES } from "../../constants";

const headers: Cell[] = [
  { data: M_TABLE_HEADERS_SYSTEM_APPNAME.SYSTEM_NAME },
  { data: M_TABLE_HEADERS_SYSTEM_APPNAME.IS_ACTIVE },
  { data: M_TABLE_HEADERS_SYSTEM_APPNAME.CATEGORY },
  { data: M_TABLE_HEADERS_SYSTEM_APPNAME.BUSINESS_UNIT },
  { data: M_TABLE_HEADERS_SYSTEM_APPNAME.SYSTEM_DESC },
  { data: M_TABLE_HEADERS_SYSTEM_APPNAME.APPROVER },
  { data: M_TABLE_HEADERS_SYSTEM_APPNAME.IS_REVOKE_NEEDED },
];

export const SystemAppName: React.FC = () => {
  const [sytemAppNameStore, setSytemAppNameStore] = useSystemAppNameStore();
  useEffect(() => {
    if (sytemAppNameStore.fetchList) {
      getDataList();
    }
  }, [sytemAppNameStore]);

  const form = Form.useManager<SystemAppNameModel>({
    id: 0,
    businessType: 0,
    systemCategory: 0,
    systemAppName: "",
    formName: "",
    thirdPartyFormUrl: "",
    accessDetailNote: "",
    approver: "",
    systemDesc: "",
    metadata: "",
    uamNote: "",
    assignmentTeam: "",
    isActive: false,
    isMultipleForm: false,
    isRevokeNeededForm: false,
    isSingleRequest: false,
    isRequireAttestation: false,
    isDataSensitive: false,
  });

  const [openSystemAppName, setOpenSystemAppName] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [selectedSystemAppName, setSelectedSystemAppName] = useState<
    SystemAppNameModel
  >();
  const [systemAppNameList, setsystemAppNameList] = useState([]);
  const [reportURL, setReportURL] = useState<string>("");
  const [isLoadingReportURL, setIsLoadingReportURL] = useState<boolean>(false);

  function getDataList() {
    api.systemappname
      .getSystemAppName()
      .then((response) => {
        setsystemAppNameList(response);
      })
      .finally(() => {
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(`Error in fetching gsap ${error}`);
      });
  }

  useEffect(() => {
    getDataList();
  }, [openSystemAppName]);

  useEffect(() => {
    if (openSystemAppName) {
      if (selectedSystemAppName) {
        form.set(Form.target.VALUE, ["id", selectedSystemAppName.id]);
        form.set(Form.target.VALUE, [
          "businessType",
          selectedSystemAppName.businessType,
        ]);
        form.set(Form.target.VALUE, [
          "systemCategory",
          selectedSystemAppName.systemCategory,
        ]);
        form.set(Form.target.VALUE, [
          "systemAppName",
          selectedSystemAppName.systemAppName,
        ]);
        form.set(Form.target.VALUE, [
          "formName",
          selectedSystemAppName.formName,
        ]);
        form.set(Form.target.VALUE, [
          "thirdPartyFormUrl",
          selectedSystemAppName.thirdPartyFormUrl,
        ]);
        form.set(Form.target.VALUE, [
          "accessDetailNote",
          selectedSystemAppName.accessDetailNote,
        ]);
        form.set(Form.target.VALUE, [
          "approver",
          selectedSystemAppName.approver,
        ]);
        form.set(Form.target.VALUE, [
          "systemDesc",
          selectedSystemAppName.systemDesc,
        ]);
        form.set(Form.target.VALUE, [
          "metadata",
          selectedSystemAppName.metadata,
        ]);
        form.set(Form.target.VALUE, [
          "assignmentTeam",
          selectedSystemAppName.assignmentTeam,
        ]);
        form.set(Form.target.VALUE, ["uamNote", selectedSystemAppName.uamNote]);
        form.set(Form.target.VALUE, [
          "isActive",
          selectedSystemAppName.isActive,
        ]);
        form.set(Form.target.VALUE, [
          "isMultipleForm",
          selectedSystemAppName.isMultipleForm,
        ]);
        form.set(Form.target.VALUE, [
          "isRevokeNeededForm",
          selectedSystemAppName.isRevokeNeededForm,
        ]);
        form.set(Form.target.VALUE, [
          "isSingleRequest",
          selectedSystemAppName.isSingleRequest,
        ]);
        form.set(Form.target.VALUE, [
          "isRequireAttestation",
          selectedSystemAppName.isRequireAttestation,
        ]);
        form.set(Form.target.VALUE, [
          "isDataSensitive",
          selectedSystemAppName.isDataSensitive,
        ]);
      }
    }
  }, [openSystemAppName]);

  useEffect(() => {
    if (reportURL === "") {
      setIsLoadingReportURL(true);
      getReportURL(REPORT_TYPES.MAINTENANCE_SYSTEM)
        .then((response) => {
          setReportURL(response);
        })
        .catch((error) => {
          throw error;
        })
        .then(() => {
          setIsLoadingReportURL(false);
        });
    }
  }, []);

  const isShowModal = openSystemAppName ? (
    <SystemAppNameDetail
      form={form}
      open={openSystemAppName}
      onCancel={() => setOpenSystemAppName(false)}
    />
  ) : (
    ""
  );

  const pageName = "System / Application Name";
  return (
    <Box mt={2}>
      <MaintenanceBreadcrumbs title={pageName} />
      {isLoadingReportURL ? null : (
        <a
          href={reportURL}
          target="_blank"
          rel="noopener noreferrer"
          style={{ float: "right" }}
        >
          GENERATE REPORT
        </a>
      )}
      <Table
        data={systemAppNameList.map((data: any) => ({
          cells: [
            {
              data: data.systemAppName,
              color: "blue",
              cursor: "pointer",
              onClick: () => {
                setSelectedSystemAppName(data);
                setOpenSystemAppName(true);
              },
            },
            {
              data: data.isActive ? "Yes" : "No",
            },
            {
              data: data.systemCategoryName,
            },
            {
              data: data.businessTypeName,
            },
            {
              data: data.systemDesc,
            },
            {
              data: data.approver,
            },
            {
              data: data.isRevokeNeededForm ? "Yes" : "No",
            },
          ],
          data: data,
        }))}
        tableName={pageName}
        searchPlaceholder="Search by System Name"
        searchColumns={[M_TABLE_HEADERS_SYSTEM_APPNAME.SYSTEM_NAME]}
        headers={headers}
        filters={[FilterType.SORT, FilterType.SEARCH, FilterType.PAGINATOR]}
        toolbar="M_SYSTEM_APPNAME_TOOLBAR"
        loading={isLoading}
      />
      {isShowModal}
    </Box>
  );
};
